import React from 'react';
import { HtmlString } from '../../shared/types/HtmlString';
import { ComponentMessage } from '../../shared/enums/ComponentMessage';
import { Link } from 'react-router-dom';

interface Props {
  value: HtmlString;
}

const PagePathCell: React.FC<Props> = props => {
  return (
    <div>
      <Link to={`/google-analytics/page-view/pageUrl=${props.value?.replace(/\//g, '*')}`}>
        {props.value ? props.value : ComponentMessage.NoDataShort}
      </Link>
    </div>
  );
};

export default PagePathCell;
